import React from "react";
import PropTypes from "prop-types";
import SearchIcon from "@/assets/home-2.svg";
import SearchArrowIcon from "@/assets/arrowIcon.svg";
import "./SearchBreadcrumb.css";

const SearchBreadcrumb = ({ items, className = "", onHomeClick }) => {
  if (!items || items.length === 0) return null;

  return (
    <nav className={`search-breadcrumb ${className}`} aria-label="Breadcrumb">
      {onHomeClick ? (
        <button
          type="button"
          className="search-breadcrumb__home-btn"
          onClick={onHomeClick}
          aria-label="Go to home"
        >
          <img src={SearchIcon} alt="Home" className="search-breadcrumb__icon" />
        </button>
      ) : (
        <img src={SearchIcon} alt="Home" className="search-breadcrumb__icon" />
      )}
      {items.map((item, index) => (
        <React.Fragment key={`${item.label}-${index}`}>
          <img src={SearchArrowIcon} alt="" className="search-breadcrumb__arrow" />
          {item.onClick && !item.isCurrent ? (
            <button type="button" className="search-breadcrumb__link" onClick={item.onClick}>
              {item.label}
            </button>
          ) : (
            <span
              className={`search-breadcrumb__text${
                item.isCurrent ? " search-breadcrumb__current" : ""
              }`}
            >
              {item.label}
            </span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

SearchBreadcrumb.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func,
      isCurrent: PropTypes.bool,
    })
  ).isRequired,
  className: PropTypes.string,
  onHomeClick: PropTypes.func,
};

export default SearchBreadcrumb;
